export class FieldLabel {
    constructor(
        label,
        placeholder,
        append
    ) {
        this.label = label;
        this.placeholder = placeholder;
        this.append = append;
    }

}

export class FieldValidation {
    constructor(
        rule,
        text
    ) {
        this.rule = rule;
        this.text = text;
    }
}

export class FieldDescription {
    constructor(
        name,
        label,
        required,
        format,
        validation,
        prompt) {
            this.name = name;
            this.label = label;
            this.required = required;
            this.format = format;
            this.validation = validation;
            this.prompt = prompt;
    }
}